module.exports = __webpack_public_path__ + "img/success.1931d54a.png";